import { constants } from '../../config';
import { get, getHeaders, post } from './services.common';
import jwt_decode from 'jwt-decode';

export const fetchCountryCodesService = async () => {
  const url = constants.API + `/identity/OTP/country-codes`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
  });
  return response;
};

export const sendOtpService = async (data: {
  countryCode: string;
  contactNumber: string;
  storeSlug: string;
  merchantStoreId: string;
}) => {
  const url = constants.API + `/identity/Shopper/send-otp`;
  const headers = { ...getHeaders() };
  const response = await post({
    url,
    headers,
    data: {
      countryCode: data.countryCode,
      contactNumber: data.contactNumber,
      merchantStoreSlugId: data.storeSlug,
      merchantStoreId: data.merchantStoreId,
    },
  });
  return response;
};

export const verifyOtpService = async (data: {
  phoneNumber: string;
  userId: string;
  storeSlug: string;
  verificationCode: number;
  merchantStoreId: string;
}) => {
  const url = constants.API + `/identity/Shopper/verify-otp`;
  const headers = { ...getHeaders() };
  const response = await post({
    url,
    headers,
    data: {
      phoneNumber: data.phoneNumber,
      userId: data.userId,
      merchantSlugId: data.storeSlug,
      verificationCode: data.verificationCode,
      merchantStoreId: data.merchantStoreId,
    },
  });
  return response;
};

export const loginMerchantService = async (data: {
  token: string;
  merchantStoreName: string;
  merchantStoreId: string;
}) => {
  console.log(data);
  const url = constants.API + `/identity/Shopper/merchant-login`;
  const headers = {
    Authorization: `Bearer ${data.token}`,
  };
  const response = await post({
    url,
    headers,
    data: {
      merchantStoreName: data.merchantStoreName,
      merchantStoreId: data?.merchantStoreId,
    },
  });
  return response;
};

export const verifyLoginService = async (data: { storeSlug: string }) => {
  const authToken = localStorage.getItem(constants.USER_TOKEN_KEY + data.storeSlug);
  const userId = localStorage.getItem(constants.USER_ID_KEY + data.storeSlug);
  const shopperAccountId = localStorage.getItem(constants.USER_SHOPPER_ID_KEY + data.storeSlug);
  const phoneNumber = localStorage.getItem(constants.USER_PHONE_KEY + data.storeSlug);
  const shopperName = localStorage.getItem(constants.USER_NAME + data.storeSlug);
  const address = localStorage.getItem(constants.USER_ADDR_L1 + data.storeSlug);

  if (authToken === undefined || authToken === null) {
    return {
      isLoggedIn: false,
    };
  } else {
    const jsonToken: any = jwt_decode(authToken);
    if (jsonToken.exp < (new Date().getTime() + 1) / 1000) {
      return {
        isLoggedIn: false,
      };
    } else {
      return {
        isLoggedIn: true,
        authToken: authToken,
        userId: userId,
        phoneNumber: phoneNumber,
        shopperAccountId: shopperAccountId,
        shopperName: shopperName,
        address: address
      };
    }
  }
};

export const logoutService = async () => {
  return {
    isLoggedIn: false,
  };
};
